module.exports = __webpack_public_path__ + "static/media/Video_caption_6.5af4a280.png";